import { Pill } from "../common";

export const FIN_STATUS = {
  PAID: { label: "✓ Pago", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  UPCOMING: { label: "A vencer", cls: "bg-sky-50 text-sky-800 border-sky-200" },
  DUE_SOON: { label: "Vence em 3 dias", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  DUE_TODAY: { label: "Vence hoje", cls: "bg-amber-100 text-amber-900 border-amber-300" },
  OVERDUE: { label: "Vencido", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  SUSPENSION_PENDING: { label: "Suspensão pendente", cls: "bg-rose-100 text-rose-800 border-rose-300" },
  SUSPENDED: { label: "Serviço suspenso", cls: "bg-slate-200 text-slate-700 border-slate-300" },
  CANCELED: { label: "Cancelada", cls: "bg-slate-50 text-slate-500 border-slate-200" },
};

export const lateText = (days) => (days < 0 ? `Pagamento vencido há ${-days} dia${days < -1 ? "s" : ""}.` : days === 0 ? "Vence hoje." : `Vence em ${days} dia${days > 1 ? "s" : ""}.`);

export const FinPill = ({ s, testid }) => <Pill cls={FIN_STATUS[s]?.cls} testid={testid}>{FIN_STATUS[s]?.label || s}</Pill>;

export const competence = (ref) => (ref ? `${ref.slice(5, 7)}/${ref.slice(0, 4)}` : "—");
